/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export const SIZE = ({
  xSmall: 'xSmall',
  small: 'small',
  medium: 'medium',
  large: 'large'
} as const);
export const HIERARCHY = Object.freeze(({
  primary: 'primary',
  secondary: 'secondary'
} as const));

/**
 * @deprecated The kind values in this object are deprecated and will be removed in future releases. Use the values in SUPPORTED_KIND instead, find the replacement from https://baseweb.design/components/tag/#supported-kind-values.
 */
export const DEPRECATED_KIND = Object.freeze(({
  neutral: 'neutral',
  primary: 'primary',
  accent: 'accent',
  positive: 'positive',
  warning: 'warning',
  negative: 'negative',
  black: 'black',
  brown: 'brown'
} as const));
export const SUPPORTED_KIND = Object.freeze(({
  custom: 'custom',
  gray: 'gray',
  red: 'red',
  orange: 'orange',
  yellow: 'yellow',
  green: 'green',
  blue: 'blue',
  purple: 'purple',
  magenta: 'magenta',
  teal: 'teal',
  lime: 'lime'
} as const));

// Defined these types here to make explicit type mapping to allow typescript to catch the deprecated kind usage with KIND constants
type DeprecatedKind = typeof DEPRECATED_KIND;
type SupportedKind = typeof SUPPORTED_KIND;
type Kind = SupportedKind & {
  /** @deprecated Use SUPPORTED_KIND.gray instead. https://baseweb.design/components/tag/#supported-kind-values */
  neutral: DeprecatedKind['neutral'];
  /** @deprecated Use SUPPORTED_KIND.gray instead. https://baseweb.design/components/tag/#supported-kind-values */
  primary: DeprecatedKind['primary'];
  /** @deprecated Use SUPPORTED_KIND.blue instead. https://baseweb.design/components/tag/#supported-kind-values */
  accent: DeprecatedKind['accent'];
  /** @deprecated Use SUPPORTED_KIND.green instead. https://baseweb.design/components/tag/#supported-kind-values */
  positive: DeprecatedKind['positive'];
  /** @deprecated Use SUPPORTED_KIND.yellow instead. https://baseweb.design/components/tag/#supported-kind-values */
  warning: DeprecatedKind['warning'];
  /** @deprecated Use SUPPORTED_KIND.red instead. https://baseweb.design/components/tag/#supported-kind-values */
  negative: DeprecatedKind['negative'];
  /** @deprecated Use SUPPORTED_KIND.gray with custom styling. https://baseweb.design/components/tag/#supported-kind-values */
  black: DeprecatedKind['black'];
  /** @deprecated no direct replacement (deprecated color). https://baseweb.design/components/tag/#supported-kind-values */
  brown: DeprecatedKind['brown'];
};

// todo: dynamic identity map generation
export const KIND: Kind = ({
  ...DEPRECATED_KIND,
  ...SUPPORTED_KIND
} as const);